<template>
  <div class="process-connection">
    <el-form class="form" :inline="true">
          <div class="connection">
            <div class="title">{{connection.defaultLine ?'默认流转':"流转"+ connectionIndex}} <i class="el-icon-close close" v-if="!connection.defaultLine" @click="delConnection(connectionIndex)"></i></div>
            <div class="process-content">
              <div class="target">
                <el-form-item label="操作按钮">
                  <el-select v-model="connection.actionId" :disabled="currentNode.type==='inclusiveGateway_start'||currentNode.type==='inclusiveGateway_end'">
                    <el-option v-if="action.type !== '打印'" :label="action.name" :value="action.id" v-for="action in getCurrentNode.actions" :key="action.id" :disabled="getCurrentNode.isCountersign===true&&disableButton.some(n => n === action.id)"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="目标节点">
                  <el-select v-model="connection.targetNodeId" @change="targetNodeIdChange" filterable>
                   <el-option :label="node.name" :value="node.id" v-for="node in targetNode" :key="node.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="操作类型" v-if="getTargetNodeTypeById(connection.targetNodeId)==='cancelEvent'">
                  <el-select v-model="connection.operationType">
                    <el-option label="终止" value="cancelEvent"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="操作类型" v-else-if="getTargetNodeTypeById(connection.targetNodeId)==='endEvent'">
                  <el-select v-model="connection.operationType">
                    <el-option label="结束" value="endEvent"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="操作类型" v-else>
                  <el-select v-model="connection.operationType">
                    <el-option label="正常" value="normal"></el-option>
                    <el-option label="返回" value="back"></el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="conditions" v-if="!getCurrentNode.isCountersign===true&&!connection.defaultLine">
                <template v-if="connection.conditions.length===0">
                  <el-form-item label="流转条件">
                   <el-button type="text" class="add-condition" @click="addCondition(connectionIndex)"> <i>+</i> 添加</el-button>
                  </el-form-item>
                </template>
                <template v-else>
                   <el-form-item label="流转条件" class="condition-header">
                   以下条件的关系为：
                   <el-button class="change-condition" @click="connection.conditionRelation=!connection.conditionRelation">{{connection.conditionRelation?'且':'或'}}</el-button>
                   <el-button class="add" type="text" @click="addCondition(connectionIndex)"><i>+</i> 添加</el-button>
                </el-form-item>
                 <table class="table-connection" cellspacing="0">
                   <tr v-for="(condition, conditonIndex) in connection.conditions" :key="conditonIndex">
                     <td>
                      <el-select  v-model="condition.nodeId" placeholder="选择节点" class="first" filterable>
                        <el-option :label="node.name" :value="node.id" v-for="node in previousNode" :key="node.id"></el-option>
                      </el-select>
                     </td>
                     <td>
                      <el-select v-model="condition.fieldId" placeholder="选择控件" filterable>
                         <el-option :label="component.name" :value="component.archive.columnId" v-for="component in  getForm(condition.nodeId)" :key="component.id"></el-option>
                      </el-select>
                     </td>
                     <td>
                      <el-select v-model="condition.operator" placeholder="选择运算符">
                        <el-option label="==" value="equal"></el-option>
                        <el-option label="!=" value="notEqual"></el-option>
                        <el-option label=">" value="greaterThan"></el-option>
                        <el-option label="<" value="lessThan"></el-option>
                        <el-option label=">=" value="greaterThanEqual"></el-option>
                        <el-option label="<=" value="lessThanEqual"></el-option>
                        <el-option label="包含" value="include"></el-option>
                        <el-option label="空" value="Null"></el-option>
                        <el-option label="非空" value="notNull"></el-option>
                        <el-option label="不包含" value="uninclude"></el-option>
                      </el-select>
                     </td>
                     <td >
                       <el-input v-show="condition.operator!=='Null'&&condition.operator!=='notNull'" v-model="condition.value" placeholder="输入比较值"  clearable></el-input>
                     </td>
                     <td class="del">
                        <i class="el-icon-remove-outline" @click="delCondition(connectionIndex,conditonIndex)"></i>
                     </td>
                    </tr>
                 </table>
                </template>

              </div>
              <div class="warning" v-if="currentNode.type!=='inclusiveGateway_start'&&currentNode.type!=='inclusiveGateway_end'" @click="openInformDialog">
                 <div class="setting"><i class="el-icon-setting"></i>更多设置</div>
              </div>
            </div>
          </div>
      </el-form>

  </div>
</template>
<script>
import Condition from '@/store/process/condition.js'

export default {
  name: 'process-connection',
  props: ['definition', 'connection', 'connectionIndex', 'currentNodeId', 'getNodes', 'connections'],
  inject: ['processService'],
  data () {
    return {
      inform: {
        connectionId: '',
        dialogVisible: false
      }
    }
  },
  methods: {
    delConnection (index) {
      this.$emit('delConnection', index, this.connection.id)
    },
    // 添加流转条件
    addCondition (connectionIndex) {
      let condition = Condition.create({})
      this.connection.conditions.push(condition)
    },
    delCondition (connectionIndex, conditionIndex) {
      this.connection.conditions.splice(conditionIndex, 1)
    },
    getTargetNodeTypeById (targetId) {
      let targetNode = this.targetNode.find(m => m.id === targetId)
      if (targetNode) {
        return targetNode.type
      }
    },
    getForm (nodeId) {
      if (nodeId) {
        let formId = this.definition.process.nodes.find(m => m.id === nodeId).formId
        return this.processService.formService.getComponentById(formId).archivedChildren
      }
    },
    openInformDialog () {
      this.inform.connection = this.connection
      this.inform.connectionId = this.connection.id
      this.inform.sourceNodeId = this.connection.sourceNodeId
      this.inform.notice = this.connection.notice
      this.inform.dialogVisible = true
      this.$emit('openDialogInform', this.inform)
    },
    //  目标节点改变时的操作
    targetNodeIdChange () {
      //  获取目标节点
      let targetNodeId = this.connection.targetNodeId
      //  获取当前节点之前的节点集合
      let beforeNodeIdList = this.previousNode.map(obj => obj.id)
      let operationType = ''
      //  判断目标节点是否在当前节点之前
      if (beforeNodeIdList.includes(targetNodeId)) {
        //  目标节点在当前节点之前，操作类型默认为返回
        operationType = 'back'
      } else if (this.getTargetNodeTypeById(targetNodeId) === 'cancelEvent') {
        //  结束节点只有结束
        operationType = 'cancelEvent'
      } else if (this.getTargetNodeTypeById(targetNodeId) === 'endEvent') {
        //  终止节点只有终止
        operationType = 'endEvent'
      } else {
        //  目标节点在当前节点之后，操作类型默认为正常
        operationType = 'normal'
      }
      this.connection.operationType = operationType
    }
  },
  computed: {
    disableButton () {
      // 对会签节点特殊处理
      return this.connections.map(m => m.actionId)
    },
    getCurrentNode () {
      return this.definition.process.nodes.find(m => m.id === this.currentNodeId)
    },
    targetNode () {
      return this.definition.process.nodes.filter(m => m.id !== this.currentNodeId)
    },
    currentNode () {
      return this.definition.process.nodes.filter(m => m.id === this.currentNodeId)[0]
    },
    previousNode () {
      let nodeIds = []
      let nodes = []
      nodeIds = this.definition.process.getpreviousNode(this.currentNodeId)
      nodeIds.forEach(m => {
        // 获取当前节点及之前的节点id集合
        nodes.push(this.definition.process.nodes.find(n => n.id === m))
      })
      return this.definition.process.getwithoutinClusiveGateway(nodes)
    }

  },
  watch: {
    'connection.targetNodeId' (newValue, oldVlaue) {
      if (newValue) {
        // 第一次目标节点没有值,下一个节点通知人没有值,所以加上为0的情况
        this.connection.notice.forEach(el => {
          if (el.targetNode.length === 0 || (el.targetNode.length === 1 && el.targetNode[0] === oldVlaue)) {
            el.targetNode = [newValue]
          }
        })
      }
    }
  }
}
</script>

<style lang="scss">
.process-connection {
  .form {
    .connection {
      background: #fff;

      &:hover {
        background: #F4F9FD;
      }

      .title {
        background: #EBF5FF;
        height: 27px;
        line-height: 27px;
        padding-left: 9px;
        position: relative;

        .close {
          position: absolute;
          top: 7px;
          right: 10px;
          color: #6BB7F3;
        }
      }

      .process-content {
        padding: 16px 8px 5px;

        .el-form-item__label
          {
          font-size: 12px;
          padding: 0 8px 0 0;
        }

        span {
          font-size: 12px;
        }

        .target {
          .el-form-item__content {
            width: 98px;
          }

          .el-form-item {
            &:nth-child(3) {
              margin-right: 0;
            }
          }
        }

        .conditions {
           >.el-form-item {
           margin-bottom: 0px;
          }
          .condition-header {
            margin-bottom: 2px;

            .el-form-item__content {
              color: #B4B5B5;
              font-size: 12px;
            }
          }

          .change-condition {
            padding: 3px 8px;
          }

          .add {
            margin-left: 248px;
          }

          .table-connection {
            margin-bottom: 16px;
            td {
              width: 105px;
            }
          }

          .table-connection,
          tr,
          td {
            background: transparent;

            .el-input__inner {
              border: none;
              background: transparent;
            }

            .first .el-input__inner {
              padding-left: 0;
            }

            td {
              border-bottom: 1px solid #E3E4E5;

              &:last-child {
                text-align: right;
                color: #6BB7F3;
                border: none;
                width: 64px;
                visibility: hidden;
                cursor: pointer;
                &:active {
                   color: #388DD2;
                }
              }
            }

            tr:hover {
              td {
                border-bottom: 1px solid #54ABF1;

                &:last-child {
                  visibility: visible;
                }
              }
            }
          }

          ::-webkit-input-placeholder {
            color: #606266;
          }

          ::-moz-placeholder {
            color: #606266;
          }

          :-ms-input-placeholder {
            color: #606266;
          }
        }

       .warning {
          position: relative;
          text-align: center;
          width: 100%;
          height: 30px;
          line-height: 30px;
          .setting {
            color: #C2C3C4;
            cursor: pointer;
            margin: 0 auto;
            width: 86px;
            font-size: 12px;
            &:hover {
              color: #6BB7F3;
            }
            i {
              margin-right: 8px;
            }
          }
        }

      }
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/components/process/design/process-connection.vue